import Link from 'components/shared/Link/Link';
import { TeaserLinkItemProps } from './types';
import { cn } from 'utils/styles';
import { TeaserLinkContent } from './BaseTeaserLinkCard';

export interface CopyTeaserLinkProps extends Omit<TeaserLinkItemProps, 'image'> {
  labelAs?: 'span' | 'h3';
}

const CopyTeaserLink = ({ linkText, url, internalPage, className, labelAs }: CopyTeaserLinkProps) => {
  return (
    <div className={`${className} md:min-w-[200px] md:max-w-[320px] `}>
      <Link
        withCtaAnalytics
        href={url}
        internalPage={internalPage}
        className={cn(
          'font-sans font-semibold',
          'group rounded-full border-current border-[1.5px]',
          'bg-transparent hover:text-current text-wrap',
          'w-full h-full py-2.5 px-4',
        )}>
        <TeaserLinkContent labelAs={labelAs}>{linkText}</TeaserLinkContent>
      </Link>
    </div>
  );
};

export default CopyTeaserLink;
